import React from 'react';
import { Video } from '../types';
import { Skeleton } from './Skeleton';

interface VideoItemProps {
    video?: Video;
    isLoading?: boolean;
    onVideoClick?: (video: Video) => void;
    pageSlug: string;
    groupSlug?: string;
}

export const VideoItem: React.FC<VideoItemProps> = ({
    video,
    isLoading = true,
    onVideoClick,
    pageSlug,
    groupSlug
}) => {
    if (isLoading || !video) {
        return (
            <figure className="component-zype-video skeleton">
                <div className="thumb-container">
                    <Skeleton shape="16x12" />
                </div>
                <figcaption className="skeleton">
                    <div className="title">
                        <Skeleton />
                    </div>
                    <div className="description">
                        <Skeleton />
                        <Skeleton />
                    </div>
                </figcaption>
            </figure>
        );
    }

    const handleClick = () => {
        if (onVideoClick) {
            onVideoClick(video);
        } else {
            // Generate the URL similar to the PHP logic
            const url = groupSlug
                ? `/${pageSlug}/${groupSlug}/${video.slug}`
                : `/${pageSlug}/${video.slug}`;

            window.history.pushState({}, '', url);
            window.location.reload(); // This would trigger the WordPress router
        }
    };

    const thumbnail = video.thumbnails && video.thumbnails.length > 0
        ? video.thumbnails[0]
        : null;

    return (
        <figure className="component-zype-video">
            <div className="thumb-container" onClick={handleClick}>
                {thumbnail ? (
                    <img
                        src={thumbnail.url}
                        alt={video.title}
                        className="thumbnail"
                        width={thumbnail.width}
                        height={thumbnail.height}
                    />
                ) : (
                    <div className="thumbnail" style={{
                        background: '#333',
                        aspectRatio: '16/9',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: '#666'
                    }}>
                        No Image
                    </div>
                )}
            </div>
            <figcaption>
                <div className="title" onClick={handleClick}>
                    {video.title}
                </div>
                {video.description && (
                    <div className="description">
                        {video.description}
                    </div>
                )}
            </figcaption>
        </figure>
    );
}; 